import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Typography, Button, Form, Input, Row, Col, Alert, Spin } from "antd";
import {
  MailOutlined,
  LockOutlined,
  UserOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

import { register } from "src/redux/actions/auth";

import { clearMessage } from "src/redux/actions/message";
import swal from "sweetalert";

const { Title } = Typography;
const App = ({ setEmail, setWa, setCurrent }) => {
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearMessage());
  }, []);

  if (isLoggedIn) {
    return <Navigate to="/" />;
  }

  const onFinish = (values) => {
    console.log("Received values from form: ", values);

    setLoading(true);
    if (!loading) {
      dispatch(
        register(values.fullname, values.email, values.wa, values.password)
      )
        .then(() => {
          swal("Success", "success", "success", {
            buttons: false,
            timer: 2000,
          });
          window.setTimeout(() => {
            //setSuccess(true);
            setLoading(false);
            //navigate("/");
            setCurrent(1);
            setEmail(values.email);
            setWa(values.wa);

            //window.location.reload();
          }, 2000);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };
  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      <Col style={{ width: "50%" }}>
        <Title level={5}>Lengkapi formulir berikut </Title>
        <Form
          name="login_form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            name="fullname"
            rules={[
              {
                required: true,
                message: "Tolong masukkan nama lengkap Anda!",
              },
            ]}
          >
            <Input
              placeholder="Fullname"
              prefix={<UserOutlined />}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Tolong masukkan email Anda!" },
              {
                type: "email",
                message: "Format email tidak valid!",
              },
            ]}
          >
            <Input placeholder="Email" prefix={<MailOutlined />} size="large" />
          </Form.Item>

          <Form.Item name="wa" rules={[]}>
            <Input
              placeholder="Whatsapp (Optional)"
              prefix={<WhatsAppOutlined />}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Tolong masukkan password Anda!" },
            ]}
          >
            <Input.Password
              placeholder="Password"
              prefix={<LockOutlined />}
              size="large"
            />
          </Form.Item>
          {!loading && message && (
            <Alert
              message={message}
              type="error"
              showIcon
              style={{ marginBottom: "16px" }}
            />
          )}
          <Form.Item>
            <Spin spinning={loading} delay={100}>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                shape="round"
              >
                Apply
              </Button>
            </Spin>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};
export default App;
